import {
  Stack,
  Typography,
  Box,
  Container,
  useMediaQuery,
  Button,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";

export default function AboutUs({ caption, txt, pic, bgcolor, btn }) {
  const matches = useMediaQuery("(min-width:600px)");
  const { t } = useTranslation();
  const lang = Cookies.get("i18next");
  return (
    <div id="about">
      <Container>
        <Box
          sx={{ justifyContent: "center", alignItems: "center", gap: "10px" }}
        >
          <Stack direction={matches ? "row" : "column"} gap={8}>
            <Stack direction="column">
              <Typography
                sx={{
                  color: "#253CA0",
                  fontWeight: "bold",
                  fontSize:
                    matches && lang === "en"
                      ? "35px"
                      : matches && lang === "ar"
                      ? "35px"
                      : "15px",
                  marginBottom: "2%",
                }}
              >
                {t(caption)}
              </Typography>
              <Typography
                sx={{
                  color: "#253CA0",
                  fontSize:
                    matches && lang === "en"
                      ? "20px"
                      : matches && lang === "ar"
                      ? "25px"
                      : "15px",
                }}
              >
                {t(txt)}
              </Typography>
              {btn && (
                <Button
                  sx={{
                    backgroundColor: "#9DC6E8",
                    padding: "10px",
                    width: "200px",
                    marginTop: "3%",
                    borderRadius: "10px",
                    fontWeight: "bold",
                    color: "white",
                  }}
                >
                  <a
                    className="nav-link"
                    href="https://play.google.com/store/apps/details?id=com.ma.ma_app_client"
                  >
                    {t(btn)}
                  </a>
                </Button>
              )}
            </Stack>
            <Box
              sx={{
                display: "flex",
                backgroundColor: `${bgcolor}`,
                width: matches ? "350px" : "280px",
                height: "300px",
                borderRadius: "20px",
                padding: "20px",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                alt="img5"
                src={pic}
                style={{
                  width: matches ? "350px" : "250px",
                  marginRight: matches ? "0px" : "0px",
                  marginTop: "-50px",
                  objectFit: "cover",
                  borderRadius: "20px",
                }}
              />
            </Box>
          </Stack>
        </Box>
      </Container>
    </div>
  );
}
